import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { router } from "router/index";
import { store } from "store";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          // fontSize: "16px",
          fontFamily: "Noto Sans CJK TC,sans-serif",
          borderRadius: 16,
          borderRadiusLG: 18,
          borderRadiusSM: 12,
          // controlHeight: 48,
          // controlHeightLG: 52,
          // paddingContentHorizontal: 16,
        },
        components: {
          Button: {
            fontSize: 16,
            borderRadius: 14,
            controlHeight: 44,
            paddingInline: 18,
          },
          Input: {
            borderRadius: 16,
            paddingBlock: 12,
            paddingInline: 16,
            fontSize: 16,
          },
          Select: {
            borderRadius: 16,
            controlHeight: 48,
          },
          Card: {
            borderRadiusLG: 18,
            paddingLG: 24,
          },
        },
      }}
    >
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </ConfigProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
